import React, { Component } from 'react';

export default class Contact extends Component {
    render() {
        return (
            <section ref={this.props.refs.Contact} id="contact" className={'contact'}>
                <div className="container">
                    <div className="box-shadow-full">
                        <div className={'contact-row'}>
                            <div className={'contact-col'}>
                                <div className={'contact-description'}>
                                    <h2>Contact</h2>
                                    <p>
                                        <p>
                                            If you have (philosophical) questions, you'd like to hire me or want to give feedback to the
                                            website,
                                            please send an email to <a href={'mailto:me@maxerler.de'}>me@maxerler.de</a>.
                                        </p>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
